import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@mui/material';
import styled from 'styled-components';

import ArrowLeftIcon from '@/assets/icons/arrow-left.svg';
import ArrowRightIcon from '@/assets/icons/arrow-right.svg';
import { useEditorContext } from '@/features/canvas/contexts/editor-context';

const ViewToggle = () => {
  const { t } = useTranslation();
  const { viewMode, setViewMode, popupVisible } = useEditorContext();

  // Check if budget is visible in popupVisible
  const isBudgetVisible = popupVisible.some(field => field.type === 'budget');

  // Automatically switch to filter view if budget is hidden while in budget view
  useEffect(() => {
    if (viewMode === 'budget' && !isBudgetVisible) {
      setViewMode('filter');
    }
  }, [isBudgetVisible, viewMode, setViewMode]);

  const handlePrevious = () => {
    setViewMode('filter');
  };

  const handleNext = () => {
    setViewMode('budget');
  };

  const currentTitle =
    viewMode === 'filter'
      ? t('editor.filter_sidebar.title')
      : t('editor.sidebar.initiative.budget.title');

  return (
    <ToggleContainer>
      {viewMode === 'budget' ? (
        <StyledIconButton onClick={handlePrevious} aria-label={t('editor.view_toggle.previous')}>
          <ArrowIcon src={ArrowLeftIcon} alt="Previous" />
        </StyledIconButton>
      ) : (
        <Spacer />
      )}

      <TitleText>{currentTitle}</TitleText>

      {viewMode === 'filter' && isBudgetVisible ? (
        <StyledIconButton onClick={handleNext} aria-label={t('editor.view_toggle.next')}>
          <ArrowIcon src={ArrowRightIcon} alt="Next" />
        </StyledIconButton>
      ) : (
        <Spacer />
      )}
    </ToggleContainer>
  );
};

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 1rem;
`;

const StyledIconButton = styled(IconButton)`
  padding: 0.4rem;
  background-color: ${({ theme }) => theme.palette.brand.white};
  border-radius: 0.5rem;
  width: 25px;
  height: 25px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);

  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.palette.brand.white};
    border: 1px solid ${({ theme }) => theme.palette.brand.backgroundDialog};
  }
`;

const ArrowIcon = styled.img`
  width: 14px;
  height: 14px;
`;

const TitleText = styled.span`
  font-size: 1.75rem;
  color: ${({ theme }) => theme.palette.brand.textPrimary};
  font-weight: 600;
`;

const Spacer = styled.div`
  width: 32px;
  height: 32px;
`;

export { ViewToggle };
